import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    TOGGLE_OFF: createAction('GLOBAL/GLOBAL_SNACKBAR/TOGGLE_OFF'),
    TOGGLE_ON: createAction('GLOBAL/GLOBAL_SNACKBAR/TOGGLE_ON'),
};
export const initialState = Map({
    active: false,
    body: null,
    variant: null,
    bodyVariables: null,
});
const reducer = handleActions({
    [actions.TOGGLE_ON]: (state, action) => state.merge(Object.assign({ active: true }, action.payload)),
    [actions.TOGGLE_OFF]: (state) => state.set('active', false),
}, initialState);
export default reducer;
export const isSnackbarActiveSelector = (state) => state.globalSnackbar.get('active');
export const snackbarBodySelector = (state) => state.globalSnackbar.get('body');
export const snackbarVariantSelector = (state) => state.globalSnackbar.get('variant');
export const snackbarBodyVariablesSelector = (state) => state.globalSnackbar.get('bodyVariables');
